import React, { useCallback, useState,useEffect } from 'react'
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import notify from "../utils/notifier";
import PreviewDialog from './PreviewDialog';
import { useHistory } from "react-router-dom";
import templateService from "../services/TemplateService";
import EditModal from "./EditModal";
import ClearIcon from "@material-ui/icons/Clear";
import * as constants from "../utils/constants"
import Item from "./Item"

const useStyles = makeStyles({ 
  canvasBox: {
    marginLeft:'100px',
    marginRight:'100px',
    marginBottom:'50px',
    paddingLeft:'20px',
    paddingRight:'20px',
    width:'70%',
    overflow: 'auto'
  },
  canvasTitle: {
    padding:'auto'
  },
  borderBox: {
    marginBottom:'50px',
    paddingLeft:'20px',
    paddingRight:'20px',
    boxShadow:'1.5px 1.5px 1.5px 1.5px #888888',
    overflow: 'auto' ,
    maxHeight:'500px'
  },
  docTextField: {
    border: 'none',
    borderBottom: '1px dotted gray',
    marginTop: '5px',
    marginBottom: '5px',
    fontStyle: 'italic',
    lineHeight: '2',
    width:'100%'
  },
  documentTable: {
    borderCollapse: 'collapse', 
    margin: '20px auto',
    width:'90%',
    height:'90%'
  },
  tableTitle: {
    paddingLeft: "10px",
    fontSize:'1.5em',
    textAlign:'center'
  },
  documentTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    textAlign: 'center', 
    width: '75%'
  },
  tableCell: {
    borderColor: 'rgb(51, 51, 51)',
    paddingTop:'0px',
    height:'50px'
  },
  button: {
    display: 'inline-block',
    marginLeft:'10px',
    marginBottom:'20px'
  },
  clearButton: {
    display: 'inline-block',
    marginLeft:'10px',
    marginBottom:'20px',
    fontSize:'10px'

  },
  addRowButton: {
    display: 'inline-block',
    marginBottom:'20px'
  },
  addLabelButton: {
    display: 'inline-block',
    marginBottom:'20px',
    fontSize:'10px'
  },
  flex: {
    display:'flex'
  },
  fieldContainer: {
    fontSize: '12px', 
    margin: 0, 
    lineHeight: '14px',
    width: '200px' 
  },
  lineSpace: {
    fontSize: '6px', 
    margin: 0, 
    lineHeight: '6px' 
  },
  fieldWidth:{
    width:'200px'
  },
  deleteIcon:{
    margin:'auto 0'
  },
  paragraphBox: {
    width: '100%', 
    padding: '10px 0px', 
    resize: 'none', 
    fontSize: '12px', 
    fontWeight: 400, 
    marginBottom: '10px', 
    borderTop: '0px', 
    borderLeft: '0px', 
    borderRight: '0px', 
    height: '30px', 
    overflowY: 'auto'
  },
  label: {
    fontSize: '12px', 
    margin: 0,
    lign:'left', 
    lineHeight: '14px', 
    fontWeight: 'bold'
  },
  mergeButton : {
    maxWidth: '30px', 
    maxHeight: '30px', 
    minWidth: '30px',  
    textAlign:'right',
    opacity:'1',
    minHeight: '30px', 
    fontSize:'10px'
  },
  alignment : {
    textAlign:'right'
  },
  cellBorder: {
    padding: '5px', 
    border: '1px solid rgb(51, 51, 51)'
  }

});


const Canvas = (props)=>{
    const classes = useStyles();

    const[focusOn, setFocus] = React.useState();
  const [documentData, setDocumentData] = React.useState({});
  const [arr, setArr] = React.useState([]);
  const [title, setTitle] = React.useState("Document Title");
  const[count, setCount] = React.useState(0);
  const CREATE_MODE = "create";
  const EDIT_MODE = "edit";

  const { data, mode } = props;

    useEffect(() => {
        if(props.mode === EDIT_MODE ){
            setDocumentData(data.json);
            setArr(Object.keys(data.json));
            getFieldMap();
            setCount(Object.keys(data.json).length)
        }
  }, []);

  function getFieldMap(){
      var jsonData = data.json;
      var array = Object.keys(jsonData);
      var map = {}
      for(let i=0;i<array.length;i++){
          var internalArray = Object.keys(jsonData[array[i]])
          for(let j=0;j<internalArray.length;j++){
              if(jsonData[array[i]][internalArray[j]]['type']==="Add Item"){
                  continue;
              }
              var temp = jsonData[array[i]][internalArray[j]]['fields'].map(e=>(
                  [e.type,e.id]));
              var val = array[i]+','+internalArray[j];
              map[val]= temp;
          }

      }
      setFieldMap(map)
  }

function splitCells(row,col){
        
        const colData = JSON.parse(JSON.stringify(documentData[row]))
        let m=0;
        const data = Object.keys(documentData[row]);
        let res = {}
        let diff = 1;
        for(let i=0;i<data.length;i++){
            
            if(parseInt(data[i])===parseInt(col)){
                if(documentData[row][parseInt(data[i])]['span'][1]===1) return;
                colData[parseInt(data[i])]['span'][1] = colData[parseInt(data[i])]['span'][1]/2;
                m=i;
            }
        }
        let temp = JSON.parse(JSON.stringify(colData[col]))
        temp.fields=[];
        delete temp['type']
        diff = colData[parseInt(col)]['span'][1];
        colData[parseInt(col)+diff] = temp;
        setDocumentData({...documentData,[row]:colData})
    }

  function mergeCells(e,row,col) {
    e.stopPropagation();
    row = parseInt(row)
    col = parseInt(col)
    const data = Object.assign({},documentData[row]);
    var currentRow='';
    currentRow = documentData[row][col]['span'][0];
    const toAddRow = documentData[row+currentRow];
    if(toAddRow===undefined) return;
    const array = toAddRow[col]
    if(array===undefined) return;
    const rows = array['span'][0];
    const next = Object.assign({},toAddRow);
    delete next[col];
    data[col]['span'][0] = rows+currentRow;
    setDocumentData({...documentData,[row]:data})
    setDocumentData({...documentData,[row+currentRow]:next})
  }

  const onclick = ()=>{

    setDocumentData({...documentData,[count]:{0:{'span':[1,4],
                                            'fields':[]}}})
    setArr([...arr,count])
    setCount(prevState => prevState + 1)

  }

const Row = (props)=>{
    return(
        <tr>
            <Col cols={props.cols} id={props.id} key ={props.id} />
        </tr> 
       

    )
}

function onDragOver(e){
    e.preventDefault();
}
function changeStateForItem(row,col,type){
    if(Object.keys(documentData[row][col]['fields']).length){
        return;
    }
    if(documentData[row] && documentData[row][col]){
        var rowSpan = documentData[row][col]['span'][0]
        var colSpan = documentData[row][col]['span'][1]
        var dataJson = {...documentData[row],[col]:{'span':[rowSpan,colSpan],'type':type,'fields':{'labels':['label'],'text':[1,1]}}}
        setDocumentData({ ...documentData, [row]: dataJson });
    }
}

const [fieldMap, setFieldMap] = React.useState({});
function onDrop(e,row,col){
    let type = e.dataTransfer.getData('id');
    let options = 'single';
    setFocus('')
    if(type==='Checkboxes'){
        options = 'mutli';
    }
    
    if(type==='Add Item'){
        changeStateForItem(row,col,type);
        return ;
    }


    if(!fieldMap[row+','+col]){
        setFieldMap({...fieldMap,[row+','+col]:[[type,0]]})
        onChange(null,type,0,row,col,documentData[row][col]['span'][0],documentData[row][col]['span'][1],options);
    }
    else{
        var fieldArray = fieldMap[row+','+col];
        var prevCount = 0;
        if(fieldArray.length){
            prevCount=fieldArray[fieldArray.length-1][1]+1;
        }
        fieldArray.push([type,prevCount])
        setFieldMap({...fieldMap,[row+','+col]:fieldArray})
        onChange(null,type,prevCount,row,col,documentData[row][col]['span'][0],documentData[row][col]['span'][1],options);
    }
   
}

function handleDelete (e,id,row,col) {
    e.stopPropagation();
    var fields = fieldMap[row+','+col].filter(f => f[1] != id)
    
    setFieldMap({...fieldMap,[row+','+col]:fields})
    
    var temp = [...documentData[row][col]['fields']].filter(f=>f['id']!=id)
    var set = Object.assign({},documentData[row][col]);

    set['fields'] = temp;
    var column = {...documentData[row],[col]:set};
    setDocumentData({...documentData,[row]:column})

}
function handleLabelAdd(click,row,col){
    click.stopPropagation();
    setFocus('')
    var rowSpan = documentData[row][col]['span'][0]
    var colSpan = documentData[row][col]['span'][1]
    var type = documentData[row][col]['type']
    var labels = [...documentData[row][col]['fields']['labels'],'label']
    var textFields = [documentData[row][col]['fields']['text'][0],documentData[row][col]['fields']['text'][1]+1]
    var dataJson = {...documentData[row],[col]:{'span':[rowSpan,colSpan],'type':type,'fields':{'labels':labels,'text':textFields}}}
    setDocumentData({ ...documentData, [row]: dataJson });

}

function handleClearItem(click,row,col){
    click.stopPropagation();
    var rowSpan = documentData[row][col]['span'][0]
    var colSpan = documentData[row][col]['span'][1]
    var type = documentData[row][col]['type']
    var colFields = {...documentData[row][col]}
    delete colFields['type']
    colFields['fields'] = []
    var dataJson = {...documentData[row],[col]:colFields}
    setDocumentData({ ...documentData, [row]: dataJson });
}

function handleLabelChange(e,row,col,index){
        var rowSpan = documentData[row][col]['span'][0]
        var colSpan = documentData[row][col]['span'][1]
        var type = documentData[row][col]['type']
        var labels = [...documentData[row][col]['fields']['labels']]
        labels[index] = e;
        var textFields = documentData[row][col]['fields']['text']
        var dataJson = {...documentData[row],[col]:{'span':[rowSpan,colSpan],'type':type,'fields':{'labels':labels,'text':textFields}}}
        setDocumentData({ ...documentData, [row]: dataJson });
}

function handleSingleClick (e,row,col,index){
    setFocus(''+row+col+index)
    e.stopPropagation();
}

const Col = (props)=>{
    if(props.cols){
        
        return(
            Object.keys(props.cols).map(e=>(
         
              <td colSpan={documentData[props.id][e]['span'][1]} onDragOver={(e)=>{onDragOver(e)}} onDrop={(p)=>{onDrop(p, props.id,e)}} onDoubleClick={()=>splitCells(props.id,e)}  rowSpan={documentData[props.id][e]['span'][0]} valign="top" height={20} className={classes.cellBorder}>
                  {!documentData[props.id][e]['type']?
                    <>
                        
                        <Condition row={props.id} col={e} rowSpan={documentData[props.id][e]['span'][0]} colSpan={documentData[props.id][e]['span'][1]}/>
                        <div className={classes.alignment}>
                            <Button onClick={(p)=>mergeCells(p,props.id,e)} className={classes.mergeButton}>+</Button>
                        </div>
                    </>
                    :<>
                        <Item row={props.id} handleChange = {handleLabelChange} labels = {documentData[props.id][e]['fields']['labels']} textFields={{'rows':documentData[props.id][e]['fields']['text'][0],'columns':documentData[props.id][e]['fields']['text'][1]}} focus = {focusOn} handleSingleClick = {handleSingleClick} col={e}/>
                        <div style={{textAlign:'center'}}>
                        <Button variant="contained" onClick={click=>handleLabelAdd(click,props.id,e)} className={classes.addLabelButton}> Add Label </Button>
                        <Button variant="contained" onClick={f=>handleClearItem(f,props.id,e)} className={classes.clearButton} >Clear </Button>
                        </div>
                        <div className={classes.alignment}>
                            <Button onClick={(p)=>mergeCells(p,props.id,e)} className={classes.mergeButton}>+</Button>
                        </div>
                    </>}
                </td>
            ))
      
        )
    }
}

const Condition = (props)=>{
    
    var fieldsArray = documentData[props.row][props.col]['fields']
    var result = [];
    if(!fieldsArray) return ;
    for(let i=0;i<fieldsArray.length;i++){
        result.push(element(fieldsArray[i]['type'],fieldsArray[i]['id'],props.row,props.col,props.rowSpan,props.colSpan))
    }
    
    return result;
}

function handleClick (e,row,col,id){
    setFocus(''+row+col+id)
    e.stopPropagation();
}

function getFields(fieldName,type,id,row,col){
    var fieldArray = [...documentData[row][col]['fields']]
    var flag=false;
    for(let i=0;i<fieldArray.length;i++){
        if(fieldArray[i]['id']===id){
            flag=true;
            fieldArray[i]['name']=fieldName;
        }
    }
    if(!flag){
        fieldArray.push({
            'id':id,
            'type':type,
            'name':fieldName
        })
    }
    return fieldArray;
}

function getMultiFields(fieldName,type,id,row,col){

    var fieldArray = [...documentData[row][col]['fields']]
    var flag=false;
    for(let i=0;i<fieldArray.length;i++){
        if(fieldArray[i]['id']===id){
            flag=true;
            if(fieldArray[i]['name'].includes(fieldName)){
                var index = fieldArray[i]['name'].indexOf(fieldName);
                if (index > -1) {
                    fieldArray[i]['name'].splice(index, 1);
                  }
            }
            else{
                fieldArray[i]['name']=[...fieldArray[i]['name'],fieldName];
            }
        }
    }
    if(!flag){
        fieldArray.push({
            'id':id,
            'type':type,
            'name':[fieldName]
        })
    }
    return fieldArray;
}
function handleClear(){
    setDocumentData({})
    setFieldMap({})
    setArr([])
    setCount(0)

}

function moveCaretAtEnd(e) {
  var temp_value = e.target.value
  e.target.value = ''
  e.target.value = temp_value
}

const [open, setOpen] = React.useState(false);
const handleClickOpen = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

const handleClose = value => {
    setOpen(false);
  };

const onChange = (e,fieldType,id,row,col,rowSpan,colSpan,type = "single") => {
    var value = "";
    if(e!=null){
        value = e.target.value;
    }
    if (type === "single") {
      var json=[]
      json = {...documentData[row],[col]:{'span':[rowSpan,colSpan],'fields':getFields(value,fieldType,id,row,col)}}
      setDocumentData({ ...documentData, [row]: json });

    } else {
        var json=[]
        json = {...documentData[row],[col]:{'span':[rowSpan,colSpan],'fields':getMultiFields(value,fieldType,id,row,col)}}
        setDocumentData({ ...documentData, [row]: json });
    }
  };

function element(componentType,id,row,col,rowSpan,colSpan){
    var value = [];
    value = documentData[row][col]['fields'].filter(f=>(f['id']===id))
    var result = focusOn==(''+row+col+id)?true:false;
    if(componentType === constants.LABEL){
        return (
            <div className = {classes.flex}>
                <input key={id}  onClick={(e)=>{handleClick(e,row,col,id)}} onChange={e => { onChange(e,componentType,id,row,col,rowSpan,colSpan) }} className={classes.label} placeholder='Enter Label' value= {value[0]===undefined?"":value[0]['name']} autoFocus={result}/>
                <p className={classes.lineSpace}>&nbsp;</p>
                <ClearIcon onClick={e=>handleDelete(e,id,row,col)} className={classes.deleteIcon} fontSize="inherit" />
            </div>
        )
    }
    else if(componentType === constants.PARAGRAPH){
        return(
            <div className = {classes.flex}>
                <textarea onClick={(e)=>{handleClick(e,row,col,id)}} onChange={e => { onChange(e,componentType,id,row,col,rowSpan,colSpan) }} value= {value[0]===undefined?"":value[0]['name']} autoFocus={result} className={classes.docTextField}  rows={4} onFocus={e=>moveCaretAtEnd(e)} placeholder="Enter Hint" data-autosize-on="true" />

                <ClearIcon onClick={e=>handleDelete(e,id,row,col)} className={classes.deleteIcon} fontSize="inherit" />
            </div>
        )
    }
    else if(componentType === constants.DROPDOWN){
        return(
            <div className = {classes.flex}>
                <p className = {classes.fieldContainer}>
                    <select onClick={(e)=>{handleClick(e,row,col,id)}} onChange={e => { onChange(e,componentType,id,row,col,rowSpan,colSpan) }} value= {value[0]===undefined?"":value[0]['name']} autoFocus={result} className={classes.docTextField} /></p>
                <ClearIcon onClick={e=>handleDelete(e,id,row,col)} className={classes.deleteIcon} fontSize="inherit" />
                
            </div>
        )
    }
    else if(componentType=== constants.CHECKBOX){
        return(
            <div className = {classes.flex}>
                <p className = {classes.fieldContainer}>
                    <input onClick={(e)=>{handleClick(e,row,col,id)}} onChange={e => { onChange(e,componentType,id,row,col,rowSpan,colSpan,'multi') }} value='default1' type="checkbox" id="default1" name="default" checked={value[0]===undefined?false:(value[0]['name'].includes('default1')?true:false)}/>
                    <label for="default1"> Default 1</label>

                    <input onClick={(e)=>{handleClick(e,row,col,id)}} onChange={e => { onChange(e,componentType,id,row,col,rowSpan,colSpan,'multi') }} type="checkbox" id="default2" name="default" value="default2" checked={value[0]===undefined?false:(value[0]['name'].includes('default2')?true:false)}/>
                    <label for="default2"> Default 2</label></p>
                <ClearIcon onClick={e=>handleDelete(e,id,row,col)} className={classes.deleteIcon} fontSize="inherit" />
            </div>
        )
    }
    else if(componentType === constants.RADIOBOX){
        return(
            <div className = {classes.flex}>
                <p className = {classes.fieldContainer}>
                    <input onClick={(e)=>{handleClick(e,row,col,id)}} onChange={e => { onChange(e,componentType,id,row,col,rowSpan,colSpan) }} value='default1' type="radio" id="default1" name="default" checked={value[0]===undefined?false:(value[0]['name']==='default1'?true:false)}/>
                    <label for="default1"> Default 1</label>

                    <input onClick={(e)=>{handleClick(e,row,col,id)}} onChange={e => { onChange(e,componentType,id,row,col,rowSpan,colSpan) }} type="radio" id="default2" name="default" value="default2" checked={value[0]===undefined?false:(value[0]['name']==='default2'?true:false)}/>
                    <label for="default2"> Default 2</label></p>
                <ClearIcon onClick={e=>handleDelete(e,id,row,col)} className={classes.deleteIcon} fontSize="inherit" />
            </div>
        )
    }
    else{
        return (
            <div className = {classes.flex}>
              <p className = {classes.fieldContainer}>
                <input onClick={(e)=>{handleClick(e,row,col,id)}} onChange={e => { onChange(e,componentType,id,row,col,rowSpan,colSpan) }} value= {value[0]===undefined?"":value[0]['name']} autoFocus={result} className={classes.docTextField} autoComplete="off" type="text"  name="123" placeholder="Enter field name"  />
              </p>
              <ClearIcon onClick={e=>handleDelete(e,id,row,col)} className={classes.deleteIcon} fontSize="inherit" />
            </div>
        )
    }
    
}

    return(
        
        <div className={classes.canvasBox}>
            <div className={classes.tableTitle}>
                    <h3 className={classes.canvasTitle}>Canvas</h3>
            </div>
        <div className={classes.borderBox}>
           <div >
            <table cellSpacing={0} cellPadding={0} className={classes.documentTable} >
                <tbody>
                <tr>
                    <td colSpan={6} align="center" className={classes.tableCell}>
                    <p type="text" name="doc_name" className={classes.documentTitle}>DOCUMENT TITLE</p><p className={classes.lineSpace}>&nbsp;</p>
                    </td>
                </tr>
                {arr.map(e =>(
                    <Row cols={documentData[e]} id={e} key={e} />
                ))}
                </tbody>

            </table>
            <div style={{textAlign:'center'}}>
                <Button variant="contained" onClick={onclick} className={classes.addRowButton}> Add Row
                </Button>
                <Button variant="contained" onClick={handleClickOpen} className={classes.button} >Preview
                </Button>
                <Button variant="contained" onClick={handleClear} className={classes.button}>Clear
                </Button>
                <EditModal
                    mode={mode}
                    title={title}
                    data={props.data}
                    json={documentData}
                />
                <PreviewDialog  open={open} json={documentData} title={title} onClose={handleClose}/>
            </div>
            </div>
            </div>
            </div>

    )
}

export default Canvas